<div class="tbs" style="background-color: #fff;">
    <div class="d-flex justify-content-around mt-5 ">
        <div class="tab-header" style="width: 100%;">
            <div class="tab first-tab" 
                [ngStyle]="{'color': tabName === 'upcomingwebinar' ? '#0D87C8' : '#D7D7D7', 'border': tabName === 'upcomingwebinar' ? '1px solid #D6D6D6' : 'none', 'border-bottom': tabName === 'upcomingwebinar' ? 'none' : '1px solid #D6D6D6', 'border-top-left-radius': tabName === 'upcomingwebinar' ? '10px' : '', 'border-top-right-radius': tabName === 'upcomingwebinar' ? '10px' : '' }" 
                (click)="activateCurrentab('upcomingwebinar')">
                <img src="../../../assets/images/upcoming webinars.svg"> Upcoming Webinars
            </div>
            <div class="tab" 
                [ngStyle]="{'color': (tabName === 'archievedwebinar') ? '#0D87C8' : '#D7D7D7', 'border': (tabName === 'archievedwebinar') ? '1px solid #D6D6D6' : 'none', 'border-bottom': (tabName === 'archievedwebinar') ? 'none' : '1px solid #D6D6D6',  'border-top-left-radius': tabName === 'archievedwebinar' ? '10px' : '', 'border-top-right-radius': tabName === 'archievedwebinar' ? '10px' : '' }" 
                (click)="activateCurrentab('archievedwebinar')">
                <img src="../../../assets/images/archieved webinar.svg"> Archived Webinars
            </div>
        </div>
        <div class="remainingtabs" style="left: 50%;
        transform: translateX(-17%);
        width: 100%;
        border-bottom: 1px solid #d7d7d7;"></div>
    </div>

    <div class="row main-card" >

        <ng-container *ngFor="let webinar of displayWebinars">
        
            <div class="categories" >
                <div class="d-flex card my-2"  (click)="viewWebinar(webinar)" style="border: 1px solid #f5f5f5; box-shadow: 0px 4px 16px 0px #0000000d;"  >  
                    <div class="card-img">
                        <span class="sponsored_tag" *ngIf="webinar?.sponsored"><img src="../../../assets/images/ph_seal-check-fill.svg" alt="">Sponsored</span>
                        <img [src]="webinar.image" width="100%" height="130px" class="img-radius"/>
                    </div>
                    <div class="card-heading">
                        <p class="card-title-heading" > {{ webinar.webinarTitle | truncateText: originalTruncateText  }} </p>
                    </div>
                    <div class="card-info">
                        <div class="card-info-calender d-flex">
                            <img src="../../../assets/images/icons/calender-icon-blue.svg" style="padding: 0px 5px;" />
                            <p class="date-time">
                                {{ (webinar?.webinarDate && webinar?.webinarTime) ? (webinar?.webinarDate + ' ' + webinar?.webinarTime) : 
                                   (webinar?.webinarDate ? webinar?.webinarDate : 'Will be announced soon') }}
                            </p>
                        </div>
                        <div class="card-info-person d-flex">
            
                            <img [src]="webinar?.hostImage" class="person-img"/>

                            <div class="personDetailsMobileview d-flex flex-column justify-content-around elipses">
                                <p class="person-name">{{ webinar?.speakersName }}</p>
                                <p class="specialization m-0">{{ webinar?.speciality }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>